<div class="content w-full" [class]="dragAreaClass" [ngClass]="{'!p-0.5': minimalView}">
  <div class="text-center w-full">
    @if(showDesc) {
    @if(minimalView){
    <p-fileupload #fileUpload class="flex-1 flex-column items-center justify-center text-center"
      [showUploadButton]="false" [showCancelButton]="false" (onUpload)="onFileChange($event)"
      (onSelect)="onFileSelect($event)" [multiple]="multiple" [fileLimit]="maxFiles">
      <ng-template pTemplate="content" let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
        let-uploadCallback="uploadCallback">
        <div class="flex justify-evenly m-0 p-0 items-center w-full cursor-pointer"
          (click)="choose($event, chooseCallback)">
          <i class="pi pi-cloud-upload text-sm"></i>
          <div class="flex flex-col text-start">
            <span class="text-xs font-bold text-gray-600">{{"Drag or Upload file here" | textCase}}</span>
            <span class="text-xs text-gray-500 ">
              @if(fileTypes.length){
              {{"Please upload" | textCase}} {{fileTypes}} {{"files only" | textCase}} ({{"Max size" | textCase}}
              {{maxFileSize/(1000 * 1000)}} {{"MB" | textCase:CASE_TYPE.LOWER}})
              }
              @else{
              ({{"Max size" | textCase}} {{maxFileSize/(1000 * 1000)}} {{"MB" | textCase:CASE_TYPE.LOWER}})
              }
            </span>
          </div>
        </div>
      </ng-template>
    </p-fileupload>
    } @else {
    <p-fileupload #fileUpload class="flex-1 flex-column items-center justify-center text-center"
      [showUploadButton]="false" [showCancelButton]="false" (onUpload)="onFileChange($event)"
      (onSelect)="onFileSelect($event)" [multiple]="multiple" [fileLimit]="maxFiles">
      <ng-template pTemplate="content" let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
        let-uploadCallback="uploadCallback">
        <div class="flex flex-col items-center justify-center w-full cursor-pointer"
          (click)="choose($event, chooseCallback)">
          <i class="pi pi-cloud-upload upload-image"></i>
          <h4 class="title">{{"Drag your files here" | textCase}}</h4>
          <p class="drag-text" tabindex="0">
            or
            <span class="click-here-input">{{"click here" |
              textCase:CASE_TYPE.LOWER}}</span>
            to upload files from your device<br>
            @if(fileTypes.length){
            {{"Please upload" | textCase}} {{fileTypes}} {{"files only" | textCase:CASE_TYPE.LOWER}} ({{"Max size" |
            textCase}} {{maxFileSize/(1000 * 1000)}} {{"MB" | textCase}})
            } @else{
            ({{"Max size" | textCase}} {{maxFileSize/(1000 * 1000)}} {{"MB" | textCase:CASE_TYPE.LOWER}})
            }
          </p>
        </div>
      </ng-template>
    </p-fileupload>
    }
    }
  </div>
</div>

@if(currentFiles.length) {
<div class="flex flex-col divide-y divide-gray-200 overflow-y-auto mt-6">
  @for (file of currentFiles; track file.name) {
  <div class="flex items-center justify-between rounded-lg py-2">
    <div class="flex items-center gap-2 min-w-0">
      <app-file-icon [type]="getFileType(file)" size="xxl"></app-file-icon>
      <div class="flex flex-col items-start">
        <span class="text-sm truncate max-w-[20rem]" [title]="file.name">{{ file.name }}</span>
        <span class="text-xs text-gray-500">{{ formatFileSize(file.size) }}</span>
      </div>
    </div>
    <app-button variant="outlined" severity="danger" icon="pi pi-trash" (clicked)="onRemoveFile(file)" />
  </div>
  }
</div>
}